<template>
  <el-form-item class="flex form-confirmation justify-end col-span-full mt-4 mb-0">
    <slot> </slot>
    <el-popconfirm :class="{ 'ml-3': $i18n.locale == 'fa', 'mr-3': $i18n.locale != 'fa' }"
      :confirm-button-text="$t('YES')" :cancel-button-text="$t('NO')" icon="el-icon-info" icon-color="red"
      :title="$t('DELETE_FORM')" @confirm="$emit('resetForm', true)" v-if="edit == null">
      <el-button slot="reference" :class="{ 'ml-2': $i18n.locale == 'fa', 'mr-2': $i18n.locale != 'fa' }" type="warning"
        plain>{{ $t("RESET_FORM_BTN") }}</el-button>
    </el-popconfirm>
    <el-button type="success" @click="$emit('submitForm', true)" :loading="loading">
      {{ title }}
    </el-button>
  </el-form-item>
</template>

<script>
export default {
  // props: ["edit"],
  props: {
    edit: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: function () {
        return this.$i18n.t("SUBMIT");
      },
    },
    loading: {
      type: Boolean,
      default: false,
      required: false,
    },
  },
};
</script>
<style></style>
